/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-3">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 0</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 2</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 5</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 4</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 10</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 1</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 9</h5>
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">RAID 15</h5>

            </vue-draggable-container>
          </vx-card>
          <vx-card class="" title="Page Switcher">
            <div class="flex items-center">
              <vs-button class="shadow-lg mr-2 w-full" color="danger" icon="icon-arrow-left" icon-pack="feather"
                         :disabled="currentPage === 0" @click="changePage('previous')">Previous Page
              </vs-button>
              <vs-button class="shadow-lg w-full" color="success" icon="icon-arrow-right" icon-pack="feather" icon-after
                         :disabled="currentPage === 3" @click="changePage('next')">Next Page
              </vs-button>
            </div>
            <p class="mt-5">Page: {{currentPage + 1}} / 4</p>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base p-2" :key="key">

            <!--- RAID 0 --->
            <div class="" :style="{'display': currentPage === pages.raid0 ? '' : 'none!important'}">
              <div class="text-center">
                <p class="mb-4 font-bold underline text-5xl">What RAID Is Being Displayed?</p>
              </div>
              <div class="flex justify-center items-center mt-6">
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-2/5"
                                         id="input0"/>
              </div>
              <div class="flex justify-center items-center mt-6">
               <img src="https://cdn.discordapp.com/attachments/937463200813834301/937472084949475378/RAID_0.png" alt="Raid0" class="w-full rounded-lg" style="max-width: 375px;">
              </div>
            </div>

            <!--- RAID 1 --->
            <div class="" :style="{'display': currentPage === pages.raid1 ? '' : 'none!important'}">
              <div class="text-center">
                <p class="mb-4 font-bold underline text-5xl">What RAID Is Being Displayed?</p>
              </div>
              <div class="flex justify-center items-center mt-6">
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-2/5"
                                         id="input1"/>
              </div>
              <div class="flex justify-center items-center mt-6">
                <img src="https://cdn.discordapp.com/attachments/937463200813834301/937473138659315792/RAID_1.png" alt="Raid" class="w-full rounded-lg" style="max-width: 375px;">
              </div>
            </div>

            <!--- RAID 5 --->
            <div class="" :style="{'display': currentPage === pages.raid5 ? '' : 'none!important'}">
              <div class="text-center">
                <p class="mb-4 font-bold underline text-5xl">What RAID Is Being Displayed?</p>
              </div>
              <div class="flex justify-center items-center mt-6">
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-2/5"
                                         id="input2"/>
              </div>
              <div class="flex justify-center items-center mt-6">
                <img src="https://cdn.discordapp.com/attachments/937463200813834301/937473152148197396/RAID_5.png" alt="Raid" class="w-full rounded-lg" style="max-width: 500px;">
              </div>
            </div>

            <!--- RAID 10 --->
            <div class="" :style="{'display': currentPage === pages.raid10 ? '' : 'none!important'}">
              <div class="text-center">
                <p class="mb-4 font-bold underline text-5xl">What RAID Is Being Displayed?</p>
              </div>
              <div class="flex justify-center items-center mt-6">
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-2/5"
                                         id="input3"/>
              </div>
              <div class="flex justify-center items-center mt-6">
                <img src="https://cdn.discordapp.com/attachments/937463200813834301/937474212250136596/RAID_10.png" alt="Raid" class="w-full rounded-lg" style="max-width: 700px;">
              </div>
            </div>

          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      key: 0,
      currentPage: 0,

      pages: {
        raid0: 0,
        raid1: 1,
        raid5: 2,
        raid10: 3
      },

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      }


    }
  },
  methods: {
    changePage (val) {
      if (val === 'next') {
        this.currentPage++
      }
      if (val === 'previous') {
        this.currentPage--
      }
    },
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          x.cancel()
        }
      }
    },
    markSimulation () {

      let total_score = 0

      if (document.getElementById('input0').textContent === 'RAID 0') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').textContent  === 'RAID 1') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').textContent  === 'RAID 5') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input3').textContent  === 'RAID 10') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism,
    shuffle
  },
  created () {
    const temp = shuffle([0, 1, 2, 3])
    this.raid0 = temp[0]
    this.raid1 = temp[1]
    this.raid2 = temp[2]
    this.raid3 = temp[3]
    this.key++

  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

